import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1173d3d3")

_pushScopeId("data-v-1173d3d3")
const _hoisted_1 = /*#__PURE__*/_createVNode("h2", null, "Contact", -1)
const _hoisted_2 = { class: "root" }
const _hoisted_3 = /*#__PURE__*/_createVNode("p", null, "If you would like to reach me directly, please feel free to fill out the form below", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" If you need to report a bug on one of my applications, please do so here: ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Report a Bug")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")
  const _component_ContactForm = _resolveComponent("ContactForm")
  const _component_Navigation = _resolveComponent("Navigation")

  return (_openBlock(), _createBlock("main", null, [
    _createVNode(_component_Navigation, null, {
      default: _withId(() => [
        _hoisted_1,
        _createVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode("p", null, [
            _hoisted_4,
            _createVNode(_component_router_link, { to: "/contact/report-bug" }, {
              default: _withId(() => [
                _hoisted_5
              ]),
              _: 1
            })
          ])
        ]),
        _createVNode(_component_ContactForm, {
          isFullNameRequired: true,
          isEmailRequired: true
        })
      ]),
      _: 1
    })
  ]))
})